// INPUT ASSIST
// orice input la focus configureaza Q.AST pe baza  input.piker --- vezi tabular data 
;
// 27 ESC
// 46 DEL
// 8 BACKSPACE
// 32 space 
// 

(function () {
    input_assistant = function () {
        var $ = this;
        // instantierea din MAIN (editing_surface) este desemnata ca target pt Q.AST  si setata ca atare
        $.trig("surface", function (_i) {
            if (_i.assisted) {
                return;
            }
            // TEXTAREA RESIZE
            // orice textarea din pagina la on hold isi recalculeaza inaltimea 
            // orice textarea isi adapteaza height la keyup,paste,etc vezi in BAC_CORE
            _i.on("dblclick", function (ev) {
                var tg = ev.target;
                if (tg.tagName === "TEXTAREA" || tg.tagName === "LOCK") {
                    //ev.stopPropagation();
                    ev.preventDefault();
                    tg.auto_resize_height();
                }
            });

            _i.on("textarea_auto_resize_height");



            // !!!! dubleaza focus si e naspa pt sleep 
            _i.on("textarea_possibly_resized", function (ev) {
                $.pin();
            });




            //  Q.AST sa dispara la click pe _i inafara unui camp asistat --  nu se poate pe body pt ca ar diparea si la utilizarea Q.AST care este appended la body
            _i.on("mousedown", function (ev) {
                $.awake && ($.awake = false);
            });// ascunderea asistentului -- nu blur ATENTIE // NU t2m ca  blocheaza scrolul

            // distributed event ---  la click pe un piker muta focus pe targetul pikerului
            _i.on('click', function focus_piker_target(ev) {
                //  console.log(_i);
                var tg = ev.target;
                if (tg.tagName === 'PIKER') {
                    //ev.stopPropagation();
                    tg.target.focus(); // orice piker are ca target un  textarea <wrap><div><piker></piker><div></wrap>  
                    tg.target.fire("keyup");
                    if (tg.target.ast === 'code') {
                        $.target = tg.target;
                        $.type = tg.target.ast;
                    }
                }
            });




            // orice input la focus configureaza Q.AST
            _i.on("focus", function (ev) {
                var tg = ev.target;
                if (tg.ast) {
                    $.target = tg;
                    $.type = tg.ast;
                    $.type !== 'lister' && ($.awake = true); // am o chestie in focus care dubleaza chestia asta
                }
                else
                    $.target = null;
            }, true);



            TCV_TRANSLATOR = {} // table->column->value mapper -- 
            _i.on("hold", async function translate_lister_value(ev) {
                var tg = ev.target;
                if (tg.tagName === 'PIKER' && !edit_switch.active) {
                    if (tg.target.ast === 'lister' || tg.target.ast === 'set_lister') {
                        var inp = tg.target;

                        arr = inp.cdf.ref.split("."), c_name = arr.pop(), ref_tb = arr.join(".");  // ne.myadr.ro.tb_name.c_name   --- full_qualified db.tb
                        if (inp.ast === 'lister') {
                            let V = inp.real_value || inp.value;
                            if (V) {
                                let { tbl, cln } = inp.cdf.ref.tblcln,
                                    path = [tbl, cln, V],
                                    R = TCV_TRANSLATOR.pointer(path);
                                if (!R) {
                                    let hint = inp.cdf.cmt.hint;
                                    if (!Array.isArray(hint)) {
                                        hint = [hint];
                                    }
                                    let POST = {
                                        tb_name: tbl,
                                        nq: inp.cdf.cmt.nq ?? "",
                                        cols: [cln, ...hint].join(),
                                        where: `${cln} = ${V}`
                                    }
                                    var project = inp.closest("[xdoc]")?.template?.project; // incer ca determin p_id nu din TE pt ca pot fi intr-un view
                                    if (project) {
                                        POST.project = project;
                                    }
                                    await ask.opt({ loader: "circle" })(__read__, POST).then(r => {
                                        R = r.parsed[0]
                                        TCV_TRANSLATOR.pointer(path, R);
                                    });
                                }
                                var str = [R].to_table(null, 1);
                                tg.shup({ info: str });
                                tg.addEventListener("mouseup", ev => {
                                    tg.poper.die();
                                    setTimeout(function () {
                                        tg.poper = null;
                                    }, 0);
                                }, { once: true }); // once 
                            }
                        }
                        else {// set translate (lista CAEN)
                            var POST = { tb_name: ref_tb, where: c_name + " IN('" + inp.value.split(" ").trim().join("','") + "')" };

                            ask(__read__, POST, function (r) {
                                var D = r.parsed, R = [];
                                D.map(s => {
                                    delete s.id;
                                    R.push(s);
                                });
                                Q.i(R, { title: inp.name + "." + c_name + " <cmt>translation</cmt>" });
                            });
                        }
                    }

                }
            });



            // PT LISTER  vvvvvv
            // previn tiparirea in listele refentiale cu mns=0 care se vor comporta ca niste selecturi + sinble line pt stringul de search la  mns>0
            // filtrare liter, cifre sageti , delete, back, enter
            _i.on("keyup", function (ev) {
                var tg = ev.target;
                //ev.stopPropagation();
                if (tg === $.target && (edit_switch.active || tg.hasA("handler"))) {
                    switch ($.type) {
                        case "lister":
                            if ((ev.which > 111 || ev.which < 48) && ev.which !== 8 && ev.which !== 32 || ev.which === 13 || ev.ctrlKey)
                                return;
                            $.lister.react_to_typing(ev);
                            break;

                        default:
                            if ($.widget?.hasOwnProperty("react_to_typing")) {
                                $.widget.react_to_typing(ev);
                            }
                            else {
                                return;
                            }
                            break;
                    }
                }


            });

            // navigez in lista 
            _i.on("keydown", function (ev) { //! nu schimba ordinea de if 
                var tg = ev.target;
                if (tg === $.target) {
                    switch ($.type) {
                        case 'lister':
                            if ([38, 40, 13].has(ev.which)) { // UP DOWN ENTER
                                ev.preventDefault();
                                ev.stopPropagation();
                                $.widget.react_to_typing(ev);
                                //Q.AST.lister.react_to_typing(ev);
                            }
                            if (tg.cdf && tg.cdf.cmt.mns === 0 && ev.which === 8) // BACKSPACE
                                tg.value = null;

                            // de aici previn completarea in liste cu valori predefinite mns=0 ---  daca pun lax=1 atunci las si valori nelistate
                            if (tg.cdf && !tg.cdf.cmt.lax && (tg.cdf.cmt.mns === 0 && ev.which !== 9 || !!tg.cdf.ref && ev.which === 13)) {
                                ev.preventDefault();
                                return false;
                            }
                            break;

                        default:
                            if ($.widget?.hasOwnProperty("react_to_typing")) {
                                $.widget.react_to_typing(ev);
                            }
                            else {
                                return;
                            }

                            break;
                    }
                }


            });


            // PT LISTER ^^^^
            /*     _i.on("blur", function (ev) {
                    if ($.target && $.type === 'lister') {
                        var tg = ev.target;
    
                    }
                }, true); */

            //            // GENERATED_COLUMNS && MORE  --- nu e bine aici 
            //            _i.on("data_change",(ev)=>{
            //                console.log(ev,ev.field); 
            //            });
            _i.assisted = true;

        });


        // asezarea in pagina a frame-ului de asistare 
        $.pin = function () {
            $.frame.x = $.target.x;
            //$.frame.y = $.target.y + $.target.h + ($.frame.offsetParent !== document.body ? $.frame.offsetParent.scrollTop : 0);    // mai sunt probleme pt parent scroll ?????????????????
            $.frame.y = $.target.y + $.target.h + 1 + (Blinder.active ? -Blinder.y + Blinder.scrollTop : 0);    // mai sunt probleme pt parent scroll ?????????????????
        };

        $.trig("awake", function (val, old_val) {
            if (!!val) {
                $.frame.css("display :block;");
                $.pin();
                window.active_assistant = $;
            }
            else {
                $.frame.css("display :none;");
                window.active_assistant = null;
            }
            $.target && $.target.fire("awake." + !!val, { assistant: $ });
        }, false);


        $.trig("type", function (t) { // schimbarea de tip 
            if (t) {
                $.widget = $[t];
                if ($.widget) {
                    $.panel.html = '';
                    $.panel._($.widget.frame);
                    $.widget.frame.style.top = 0;
                    $.widget.frame.style.left = 0;
                    $.widget.frame.remA("hidden");
                    if ($.widget.config) {
                        $.widget.config($.target);
                    }
                    else {
                        $.widget.input = $.target;
                    }
                }
                else {
                    console.log("Q.AST has no '" + t + "' widget");
                }
            }
        });

        // constructie interna
        $.frame = _E("<div assistent_frame style='display:none;position:absolute;top:-100px;left:-100px;z-index:333333'></div>");
        $.frame.assistant = $;
        $.panel = _E("<div style='position:relative;' _rb></div>");
        $.frame._($.panel);
        $$(function () {
            document.body._($.frame);
        });
    };


    Object.defineProperty(input_assistant.prototype, "toString", {
        value: function () {
            return "InputAssistant";
        }
    });

    Q.AST = new input_assistant();



    // repozitionare widget daca depaseste marginea din dreapta a browser-ului
    window.on("input_assist_panel_ready", function (ev) {
        var $ = Q.AST.widget;
        $ && setTimeout(
            function () {
                if ($.frame.style.display !== 'none' && $.frame) {
                    try {
                        var dR = document.documentElement.clientWidth - $.frame.x - $.panel.offsetWidth;
                        dR < 0 && ($.frame.style.left = (dR - 10) + 'px');
                    } catch (err) {
                    }
                }
            },
            100
        );
    });
    // Q.AST.frame position corection
    window.on("mouseup", function (ev) {
        // ????? BUBA
        //Q.AST.target !== ev.target && document.activeElement === Q.AST.target && 
        !!Q.AST.awake && Q.AST.target.fire("textarea_possibly_resized");
    });

})();







// LISTER


/**
 * ideea e : 
 * daca un cimp dintr-o tabela.sql are foreign key catre o alta tabela trebuie sa pun la dispozitia user-ului  lista cu valori posibile 
 * -- si -- 
 * ca sa aleaga in cunostinta de cauza niste hinturi 
 * pt listele cu valori multe trebuie sa fac citire limitata => mns (minimum search letters)
 * daca vreau si o afisare mascata folosesc map2 => un imput are value si real_value
 * 
 * @param invoker -- este Q.AST ca obiect parinte pt lister, calendar, filer ....
 */
Lister = function (invoker) {
    var $ = this;
    $.invoker = invoker || null;
    $.frame = _E("<div style='position:absolute;z-index:2;'></div>");
    $.head = _E("<div lister_head><div>");
    $.panel = _E("<ul lister_panel style=''></ul>");
    $.frame._($.head, $.panel);
    $.panel.on("click", function (ev) { // actiune asupra inputului inregistrat ca target
        ev.stopPropagation();
        var tg = ev.target, li;
        if (tg.tagName === "LI") {
            li = tg;
        }
        else {
            li = tg.closest("li");
        }
        if (li.data) {
            $.put_value_and_hide(li);
        }
    });
};
Lister.prototype = {
    config: function (elm) {
        var $ = this;
        $.panel.html = '';
        $.target = elm;
        $.search_str = null;
        $.r_list = []; // BAC???
    },
    react_to_typing: function (ev) {
        var $ = this, I = ev.target, val = I.value, len = val.length, mns = $.target.cdf.cmt.mns;
        // anunt user ca trebuie sa introduca ceva de la tastatura pt a genera lista
        if (len < mns && !ev.isTrusted || len < mns && [38, 40, 13].has(ev.which)) {
            I.piker.shup({ info: "<h4><c>" + mns + "</c>&nbsp;CHAR" + (mns > 1 ? "S" : "") + " REQUIRED!</h4><hr/>PATTERNS: <h4>1*   .*</h4>", time: 4000 });
        }
        // wake-up Q.AST 
        if ($.invoker && !$.invoker.awake) {
            $.invoker.awake = true;
            $.invoker.panel._($.frame);
        }
        if ([38, 40, 13].has(ev.which) && $.panel.html !== '') { // daca am panelul cu rezultate populat fac navigare cu sagetile si selectie cu ENTER
            $.navigate(ev);
        }
        else {
            if (mns === 0) {
                if (
                    !Lister.ready[$.target.tb_name] ||
                    !Lister.ready[$.target.tb_name][$.target.name] // nu am date citite
                    || $.target.cascade_cleared
                    || $.target.cdf.cmt.no_cache // vreau sa fortez recitirea din server - Ex pt lista aloc dupa realoare
                    || $.target.cdf.cmt.client_hinted_list
                ) {
                    $.fetch('');
                }
                else {
                    clearTimeout($.timeout);
                    $.key_buffer = ($.key_buffer || '') + ev.key;
                    $.timeout = setTimeout(() => {
                        $.build(val, { letter: $.key_buffer });
                        $.key_buffer = '';
                    }, 300);
                }
            }
            else {
                if (len >= mns && val.indexOf($.search_str) !== 0) {
                    $.fetch(val);
                }
                else {
                    $.build(val);
                }
            }
        }
    },
    navigate: function (ev) {
        var $ = this;
        var sel = $.panel.find("[selected]", 1);
        var sense = typeof ev === 'string' ? ev : ev.which;
        if (!sel) {
            $.panel.first.setA("selected");
        }
        else {
            sel.remA("selected");
            switch (sense) {
                case "up":
                case 38: // up
                    $.target && $.target.set_cursor_poz('last');
                    if (sel.prev) {
                        sel.prev.setA("selected");
                        $.panel.scrollTop = sel.prev.offsetTop;
                    }
                    else {
                        //$.panel.last.setA('selected');
                        // $.panel.scrollTop=$.panel.scrollHeight-5;
                    }
                    break;
                case "down":
                case 40: // down
                    if (sel.next) {
                        sel.next.setA("selected");
                        $.panel.scrollTop = sel.next.offsetTop;
                    }
                    else {
                        sel.setA("selected");
                        //$.panel.first.setA("selected");
                        //$.panel.scrollTop=-5;
                        $.panel.scrollTop = $.panel.scrollHeight;
                    }
                    break;
                case "take":
                case 13:
                    $.put_value_and_hide(sel);
                    break;
            }
        }
    },
    put_value_and_hide: function (sel) { // li element   li.data + li.all_data
        var $ = this, new_val = Array.isArray(sel.data) ? '' : sel.data;
        $.invoker && ($.invoker.awake = false);
        if ($.target && $.target.value !== new_val) { // alocare valoare in input
            $.target.value = new_val;
            $.target.old_real_value = $.target.real_value ?? '';
            $.target.real_value = sel.real_value ?? '';
            $.target.all_data = sel.all_data;
            if ($.target.cdf.cmt.fkid) { // fkid assist
                var key_to_keep = $.target.cdf.ref.split(".").pop(); // 'ALL_ADT.ref_tb.ref_col'  
                if (!key_to_keep) {
                    console.log("FKID utilizat fara  cmt.ref in tabela ??", $.target);
                }
                var colector = COLECTED_FKID_HINTS[$.target.tb_name][$.target.name];
                if (!colector) {
                    colector = COLECTED_FKID_HINTS[$.target.tb_name][$.target.name] = {};
                }
                if (!colector.hasOwnProperty(sel.all_data[key_to_keep])) {
                    var p = sel.all_data.raw_copy();
                    delete p[key_to_keep];
                    colector[sel.all_data[key_to_keep]] = p;
                }
            }
            if ($.target.cdf.cmt.map2) { // 
                // !!!BAC>>> da in bot daca nu folosesc Object.pointer
                // BUG: daca am map2 sub forma  concat(l_name,' ',f_name) da in bot rau de tot  -- la pointer e stack.overflow
                // MAP2_DICTIONARY[$.target.cdf.ref][$.target.cdf.cmt.map2][$.target.real_value] = $.target.value;
                MAP2_DICTIONARY.pointer([$.target.cdf.ref, $.target.cdf.cmt.map2, $.target.real_value], $.target.value);
            }
            $.target.fire("change", { change_by_assist: true });
            setTimeout(function () {
                $.target.fire("dblclick"); // resize_textarea_height 
            }, 10);
            $.target.valid_option = true;
            $.change(sel.all_data);  // callback definit in cdf.cmt
        }
    },
    fetch: function (val, cb, translate_id) { // AR TREBUI O LOGICA MNS cu memorarea stringului pt care s-a facut citirea + setul de date  
        var $ = this;
        clearTimeout($.timer); // daca am xhr care urmeaza a fi lansat dau cancel la setTimeout
        $.xhr && $.xhr.abort(); // daca am un ask lansat il intrerup
        // console.log($.target.cdf);
        // FOREIGN_KEY - OR - ref in cmt // din definitia sql pot suprascrie ref-ul din foreign_key 
        if ($.target && $.target.cdf.ref) {
            var cdf = $.target.cdf, ask_data;

            if ($.target.cdf.cmt.client_hinted_list instanceof Function) {
                let F = $.target.cdf.cmt.client_hinted_list;
                let D = F.bind($.target)($.target);
                if (D[0] && Object.isExtensible(D[0])) {
                    // console.log(D[0]);
                    if (!D[0].id) {
                        throw Error("data build from js must be as {id: 123, hint_1:'...', hint_2:'...' } with mandatory id");
                    }
                }
                Lister.ready[$.target.tb_name][$.target.name] = [[null], ...D];
                $.build(val)
                return;
            }
            // EVAL --- RESCRIERE DYNAMICA TOTALA  !!!BAC
            if (cdf.cmt.eval) { // aici am posibilitatea de a modifica query-ul dinamic  ex eval(cdf.cmt.where = "apel ="+ session.tmp.apel)  
                typeof cdf.cmt.eval === 'function' ? cdf.cmt.eval.bind(cdf)($.target) : eval(cdf.cmt.eval);
            }
            // SQL
            if (cdf.cmt.sql) {  // !!!BAC>>> named query -- ar trebui sa interzic ( SELECT ...) AS T pt ca expun tabele in client
                ask_data = {
                    tb_name: "(" + cdf.cmt.sql + ") AS T",
                    type: cdf.cmt.fetch || 2, //  aduc  default associative
                    where: cdf.cmt.where || " 1 ", //  ca sa nu dea in bot extra_where  pun  1 
                    order: cdf.cmt.order || "",
                    limit: cdf.cmt.limit || "",
                    preg: cdf.cmt.preg || "",
                    PUI: TE.PUI,
                    project: history.now?.project
                };

                // CASCADING FROM SQL COMMENT 
                if (cdf.cmt.cascade) {
                    var t = cdf.cmt.cascade;
                    (typeof t === 'string' ? [t] : t).map(function (c_name) {
                        var LS = $.get_logical_sibling(c_name);
                        ask_data.where += " AND " + c_name + "='" + (LS.real_value || LS.value) + "'";
                    });
                } p
            }
            else { // compunere pt XDOC din cdf-ul elementului asistat

                var arr = (cdf.cmt.ref || cdf.ref).split("."), // !!!BAC>>>   atentie   `ne.myadr.ro`.tb_name.column_nmame
                    c_name = arr.pop(), tb_name = arr.join('.');

                var hint = cdf.cmt.hint || '', // "col1,col_b" 
                    where = (cdf.cmt.where ? cdf.cmt.where + " AND " : "") +
                        (cdf.cmt.map2 || c_name) + // valori tinta mascate sau nu 
                        (cdf.cmt.rgx ? " REGEXP '" + cdf.cmt.rgx.replace("$$", val) + "'" : "  REGEXP '^" + (val === "*" ? "" : val) + ".*' "), // cmt.RGX
                    order = cdf.cmt.order || cdf.cmt.map2 || '';

                if (cdf.cmt.map2 && !hint.includes(cdf.cmt.map2)) { // !!!BAC>>> nu mai e nevoie sa pun in hint si numele coloanei de mascare
                    hint = cdf.cmt.map2 + (hint ? "," + hint : ''); // :)) array + ","+ string 
                }



                // CASCADING INPUTS ---   in coloana  A_name am  in  cdf.cmt.cascade='B_name' ---  adica valoarea lui A depinde de B --- la modificarea lui B a este resetat 
                // A are ref deci in tabela de cautare trebuie sa am colanele A si B musai --- o sa am WHERE a REGEXP '^+A.value AND B=B.value
                var stop = false;

                // !!!BAC>>> resets ??? 
                if (cdf.cmt.cascade && !/:0$/.test(cdf.cmt.cascade)) {
                    //                            console.log("######################");
                    var t = cdf.cmt.cascade;
                    (typeof t === 'string' ? [t] : t).map(function (c_name) {   //    !!!BAC>>>
                        var LGS = $.get_logical_sibling(c_name);
                        if (!LGS.value) {
                            LGS.show_error("REQUIRED FIRST", 1000);
                            LGS.focus();
                            LGS.tmpA("spark");
                            stop = true;
                            $.target.blur();
                        }
                        where += " AND " + c_name + "='" + (LGS.real_value || LGS.value) + "'";  // !!!BAC>>> la rerload pierd real value de pe camp -- mai am doar in stack
                    });
                }

                if (cdf.cmt.reseted_by && 0) {
                    for (let c_name in cdf.cmt.reseted_by) {
                        var LGS = $.get_logical_sibling(c_name);
                        if (!LGS.value) {
                            LGS.show_error("REQUIRED FIRST", 1000);
                            LGS.focus();
                            LGS.tmpA("spark");
                            stop = true;
                            $.target.blur();
                            break;
                        }
                        //where += " AND " + c_name + "='" + (LGS.real_value || LGS.value) + "'"; // !!!BAC>>>  nu e bine !!!!!!
                    }
                }

                if (stop) {
                    return;
                }
                //console.log(TE.project)
                ask_data = {
                    tb_name: tb_name,
                    cols: (cdf.cmt.distinct ? 'distinct ' : '') + c_name + (hint ? "," + hint : ""),
                    where: where,
                    type: cdf.cmt.fetch || 5,
                    order: order,
                    project: history.now?.project,
                    PUI: TE.PUI, // daca exita modifica tgdb -- acces de la front-office
                    // project: TE.project, -- nu are rost sa ocup prorietatea (am header sent)
                    //action: TE.action,
                };

                if (cdf.cmt.nq) {
                    ask_data.nq = cdf.cmt.nq;
                }
            }

            //  DYNAMIC_WHERE  
            //- in CDF.CMT  ---  se adauga din interface_name.js  in   _i.on('completion',ev=>{})  altfel poate fi suprascris de x-form
            if (cdf.cmt.dynamic_where) {
                // aici am posibilitatea de a modifica query-ul dinamic  cu valori din js --  trebuie sa intoarca o conditie SQL ( apel=5 ...)
                var str = cdf.cmt.dynamic_where.bind($.target)($.target, ask_data);
                if (str.error) { // semnal error 
                    typeof str.error === 'string' && $.target.show_error(str.error);
                    return;
                }
                if (str) {
                    if (ask_data.where) {
                        ask_data.where += " AND " + str;
                    }
                    else {
                        ask_data.where = str;
                    }
                }
            }

            // DYNAMIC_OVERRIDE
            // pot suprascrie dynamic tot ce e in ask_data  inclusiv tabela de pe care citesc 
            // TE.tdf.tb_name.c_name.dynamic_override = function(inp){ ...js_code.... return object }  // avoid arrow function ()=>{} not binding
            if (cdf.cmt.dynamic_override instanceof Function) {
                let o = cdf.cmt.dynamic_override.bind($.target)($.target, ask_data);
                if (o.error) {
                    typeof o.error === 'string' && $.target.show_error(o.error);
                    return;
                }
                ask_data.tail(o);
            }

            !!LS.verbose && console.log(ask_data); // SEE IN CONSOLE 
            if (translate_id) {
                let ref_col = "id";
                if (cdf.ref) {
                    ref_col = cdf.ref.split(".").pop();
                }
                ask_data.where += (ask_data.where ? " AND " : "") + ref_col + "= " + translate_id;
            }
            $.timer = setTimeout(
                function () {
                    ask(
                        "db\\read.val",
                        ask_data,
                        function (rez) { // done callback
                            $.search_str = val;
                            $.r_list = rez.parsed;
                            // NULL in topul hited_list -- daca nu am camp required trebuie sa pot pune null in imput
                            !cdf.req && $.r_list.unshift([null]);

                            $.xhr = null;
                            $.timer = null;
                            if (cdf.cmt.mns === 0) {
                                if (!Lister.ready.hasOwnProperty($.target.tb_name)) {
                                    Lister.ready[$.target.tb_name] = {}
                                }
                                Lister.ready[$.target.tb_name][$.target.name] = $.r_list; // practic cache la minim search  0 
                            }
                            $.target.cascade_cleared = null;// !!! cred ca in session.modify
                            $.build(val);
                            cb && cb(rez);
                        },
                        null, // fail callback
                        { target: $.target.prev, loader: "local_loader", mem: $ } // loader animation placement and type
                        //!!!BAC>>>  mem e in  Q.ajax   a se verifica 
                    );
                },
                300
            );
        } else {
            throw new Error("LISTER.target=" + $.target + " need to set ref for this input.cdf");
        }

    },
    build: function (val, opt = {}) {
        var $ = this;
        $.panel.html = '';
        val = val || $.target.value;
        var docfg = document.createDocumentFragment();
        if (typeof val === 'string' || typeof val === 'number') { // prelucrare assisted input value ...  de aici face scrolul pt valoarea din input
            if ($.target.cdf.cmt.mns === 0) {  // SELECT LIKE
                var slk, letter_select = null, letter = opt.letter;
                if (letter === '(') { // corectie pt arrow dowm
                    letter = "\\(";
                }
                Lister.ready[$.target.tb_name][$.target.name].map(function (set) {
                    var li = $.make_li(set, opt);
                    docfg._(li);
                    if ($.target.value + '' === li.data + '') {
                        slk = li;
                    }
                    if (letter && ("^" + letter).rgx.test(li.data) && !letter_select) {
                        letter_select = li;
                        //console.log(letter_select);
                    }
                });

                if (letter_select) {
                    setTimeout(
                        function () {
                            $.panel.scrollTop = letter_select.offsetTop;
                            letter_select.setA("selected");
                        },
                        0);
                }
                else if (slk) {
                    slk.setA("selected");
                    setTimeout(function () {
                        if (!letter_select) {
                            $.panel.scrollTop = slk.offsetTop;
                        }
                    }, 0);
                }

            }
            else if (val.length > 1 || val.length === 1 && $.target.cdf.cmt.mns === 1) {
                var search_by;
                if ($.target.cdf.cmt.fetch === 3) { // aduc array of arrays si prin conventie am arr[0] pentru id 
                    search_by = 0;
                }
                else {
                    if ($.target.cdf.cmt.map2) {
                        search_by = $.target.cdf.cmt.map2;  // ref: `db`.`tb`.col   --> search_by = col 
                    }
                    else {
                        var arr = $.target.cdf.ref.split(".");
                        search_by = arr.pop();   // ref `db`.tb_name.c_name
                    }
                }
                if (val === "*") {
                    val = ".*";
                }
                // suprascriere cu cdf.cmt.rgx
                var no_diacritcs_val = removeDiacritics(val);
                var rgx = $.target.cdf.cmt.like ? new RegExp(no_diacritcs_val, "im") : $.target.cdf.cmt.rgx ? new RegExp($.target.cdf.cmt.rgx.replace("$$", no_diacritcs_val), "i") : new RegExp("^" + no_diacritcs_val.replace(/\(/gim, '\\(').replace(/\)/gim, '\\)'), "i");
                //var has_null= !$.target.cdf.req;

                $.r_list.map(function (set, idx) {
                    if (rgx.test(set[search_by])) { // AM INTRODUS NULL 
                        docfg._($.make_li(set, opt));
                    }
                });
            }
        }
        else { // array of sets -- value is not important
            val.map(function (set, idx) {
                opt.tail({ idx: idx });
                docfg._($.make_li(set, opt));
            });

        }

        $.panel._(docfg);
        $.panel.fire("input_assist_panel_ready", { lister: $ });// ????? 
        $.target.fire("input_assist_panel_ready", { panel: $.panel, lister: $ });
    },
    make_li: function (set, opt) {
        var $ = this;
        var li = _E('li');
        if (set.istype("Array")) {
            li.data = set[0];
            if (set[0] === null) { // aici am facut in \db\read.val un array_unshift pt a pune null la inceputul hinted lists
                li.data = [null];
                li.css("height:3em");
                li.html = "<div style='margin-top:.5em'>NULL</div>";
            }
            else {
                li.html = set.join(" <br/> ");
            }

            li.all_data = set;
        }
        else {
            if (set.hasOwnProperty('sv')) {
                li.sv = set.sv;
                li.css("height:3em");
                li.html = `<div special_value style='margin-top:.5em'>${set.sv}</div>`;
            }
            else {
                var cdf = $.target.cdf,
                    rfc = cdf.ref.split(".").pop(), // referenced colun name 
                    map = cdf.cmt.map2,
                    hide = cdf.cmt.hide || [];
                if (map) {
                    li.data = set[map];
                    li.real_value = set[rfc];
                }
                else {
                    li.data = set[rfc];
                    li.real_value = null;
                }
                li.all_data = set;
                for (var v in set) {
                    if (v === map || !map && v === rfc) {
                        li._top("<h6 style='margin:0'><b>" + set[v] + "</b></h6>");
                    }
                    else {
                        if (!hide.has(v)) {
                            if (/^\{/.test(set[v])) {
                                try {
                                    var d = set[v].eval, s = "<tb style='border-left:.7px solid ;display:inline-block;vertical-align:top;padding-left:.5em'>";
                                    d.scan((a, b) => {
                                        s += "<r><m style='font-family:arial;line-height:1em'>" + a + "</m> = <m style='color:brown'>" + Q.gshup(b, 60) + "</m></r>"
                                    });
                                    s += "</tb>";
                                    li._("<m k>" + v + "</m> " + s + "<br/>");
                                } catch (error) {
                                    console.log(error, v, set[v])
                                    li._("<m k>" + v + ":</m> " + Q.gshup(set[v], 100) + "<br/>");
                                }
                            }
                            else {
                                li._("<m k>" + v + ":</m> " + Q.gshup(set[v], 100) + "<br/>");
                            }
                        }
                    }

                }
            }
        }
        return li;
    },
    change: function (obj) {
        var cb = this.target.cdf.cmt.change;
        (cb || nf)(obj);
    },
    /*
    ideea e sa nu stresez mysql cu maparea valorilor la reloadul peste date editate ci sa aduc odata si sa caut local -- ca un cache de valori 
    */
    remap_inputs: async function (template, FORCE_ARRAY) {
        var A = FORCE_ARRAY || template.inputs_to_remap;
        var LIST = {}, NQ = {}, B = [];
        //var BEFORE = JSON.parse(JSON.stringify(MAP2_DICTIONARY));
        A.map(e => {
            if (e.value) {
                let ref = e.cdf.ref,
                    map2 = e.cdf.cmt.map2,
                    push = true,
                    real_value = false;

                if (e.real_value) { // a fost deja mapat --  nu mai intreb serverul
                    push = false;
                }
                else {
                    // maparea din cache-ul local
                    // 1.  este afishata valoarea mapata 
                    if (edit_switch.active) {
                        real_value = (MAP2_DICTIONARY.pointer([ref, map2]) || {}).miror()[e.value];
                        if (real_value) {
                            e.real_value = real_value;
                            push = false;
                        }
                    }
                    // 2. fallback la maparea dupa valoarea din input daca nu am gasit maparea dupa valoarea afisata 
                    if (!real_value) { // am id pe post de valoare 
                        real_value = MAP2_DICTIONARY.pointer([ref, map2, e.value]);
                        if (real_value) {
                            e.real_value = e.value;
                            e.value = real_value;
                            push = false;
                        }
                    }
                }
                if (push) {
                    if (!LIST.hasOwnProperty(ref)) {
                        LIST[ref] = {};
                    }
                    if (!NQ.hasOwnProperty(ref) && e.cdf.cmt.nq) {
                        NQ[ref] = e.cdf.cmt.nq;
                    }
                    if (!LIST[ref].hasOwnProperty(map2)) {
                        LIST[ref][map2] = {};
                    }
                    LIST[ref][map2][e.value] = null;
                    B.push(e); // retin numai elementele pt care nu am date in MAP2_DICTIONARY
                }
            }
        });
        Object.keys(LIST).length && B.length && await ask("db\\read_ext\\remap_hinted_lists", {
            list: LIST,
            nq: NQ,
            PUI: template.PUI,
            project: template.project
        }).then(function (r = {}) {
            let R = r.parsed;
            B.map(e => {
                try {
                    // console.log(e, e.value, e.real_value, MAP2_DICTIONARY);
                    e.real_value = e.value;
                    e.value = R[e.cdf.ref][e.cdf.cmt.map2][e.real_value];

                    MAP2_DICTIONARY.pointer([e.cdf.ref, e.cdf.cmt.map2, e.real_value], e.value); // accumulez in dictionar si valorile citite la remap ca sa nu mai intreb serverul la urmatoarele remapari  -- practic cache local pentru map2
                } catch (error) {
                    //console.log(error, e, "####");
                }
            });
        });
        // BAC && Q.monitor({ inainte: BEFORE, dupa: MAP2_DICTIONARY }, { title: Date.now() })
        return Promise.all([]);
    },

    get_master_template_data_path: function (tg, template) {

        var X = tg.closest('[xdoc]');
        if (!X) {
            //  console.log(tg, "BUBA CU TE.remap_inputs pt binded columns")
            return null;
        }
        var
            tb_name = X.getA("xdoc").trim(),
            path = [];
        if (!template.columns[tb_name]) { // pot fi intr-un view care are alt template
            tb_name = tg.tb_name
            template = tg.closest("[template_name]").template;
        }
        var
            ord = template.columns[tb_name].indexOf(tg.name);

        switch (X.tagName) {
            case 'X-FORM':
                var t = X.xform_edited_input_path(tg), path = t.path;
                break;
            case 'X-GRID':
            case 'X-GRID-EDITOR':
            case 'X-DOSSIER':
                var t = X.edited_input_path(tg), path = t.path;
                break;
            case 'TABLE':
                path = X.oo.path_to_td(tg.parent);
                break;
            case 'FOX':
                path = [tb_name, tg.rowIndex, ord];
                break;
            case 'FORM':
                if (X.hasA("comp_parent_name")) {
                    var comp_id = X.getA("comp_parent_id");
                    path = [tb_name, comp_id, 0, ord];
                }
                else {
                    path = [tb_name, 0, ord];
                }
                break;
            case "COMP":
                path = [tb_name, X.comp_id, tg.parent.parent.rowIndex, tg.parent.colIndex];
                break;
            default: // FLIKE
                var sbj = X.getA('subject'), pfkid = X.getA("pfkid"), z_data = template.data[tb_name][sbj][pfkid];
                var ridx = z_data.find_set(X.getA('rid'), 0, 1);
                path = [tb_name, sbj, pfkid, ridx, ord];
                break;
        }
        return path;
    },
    get_logical_sibling: function (c_name) { //  se foloseste pt cascaded imputs   ex localitati.cmt {"cascade":"judet"} /// BAC??? ar mai fi de facut aici
        var
            tg = this.target,
            logical_parent = tg.closest("[logical_row]"),
            logical_sibling = logical_parent.find("[name='" + c_name + "']", 1);
        return logical_sibling;
    }
};

Object.defineProperty(Lister.prototype, "toString", {
    value: function () {
        return "Lister";
    }
});

Lister.ready = {}; // acumularea de valori citite






Q.AST.lister = new Lister(Q.AST);
Q.AST.lister.frame.setA("escdie");


Object.defineProperty(EP, 'data_path', {
    get: function () {
        return TE ? Lister.prototype.get_master_template_data_path(this, TE) : null;
    }
});

Object.defineProperty(EP, "data_descriptor", {//  {path:[tb_name,rid,ord],data:{c_name:val,.....}}
    get: function () {
        //console.trace(this);
        if (!window.TE) {
            return {};
        }
        else {
            var path = this.data_path;

            if (!path) {
                return;
            }
            var
                tb_name = path[0],
                rix = path[1], o, columns, data;
            if (this.desc(MAIN)) {
                data = (edit_switch.active || session.changes) ? session.edited_data[tb_name][rix] :
                    (TE.memorize ? session.edited_data[tb_name][rix] : TE.data[tb_name][rix]);
                columns = TE.columns[tb_name];
                // memorize problem

            }
            else { // in view sau un sub-template 
                var template = this.closest("[template_name]").template;
                data = template.data[tb_name][rix];
                columns = template.columns[tb_name]

            }
            /*
            if (!data || !data.length) { // memorized changes applied or smth else 
                var lr = this.closest("[logical_row]");
                data = lr.data
                data = [];
                columns.map((c_name, idx) => {
                    let inp = lr.find(`[name=${c_name}]`, 1);
                    if (inp) {
                        data.push(inp.value)
                    }
                    else {
                        let elm = lr.find(`[c_name=${c_name}] [dummy]`, 1);
                        data.push(elm.getA("dummy"))
                    }
                });
            }*/
            o = { path, data: [].combine(columns, data) }
            o.qfs = tb_name + "/" + o.data.id + "/" + this.name + "/"; // /var/qfs/host_name/tb_name/id/column_name/  
            return o;
        }
    }
});
Object.defineProperty(EP, "db_row_id", {
    get: function () {
        let dsc = this.data_descriptor;
        return dsc ? dsc.data.id : null;
    }
});
Object.defineProperty(EP, "qfs_path", {
    get: function () {
        let dsc = this.data_descriptor;
        if (!dsc) {
            return
        }
        let d = this.data_descriptor.qfs;
        return "/" + location.host + d.replace(/^\/qfs/, "");
    }
});

Q.AST.calendar = new Calendar(Q.AST);
Q.AST.calendar.config = function (input) {
    var $ = this;
    $.input = input;
};


// CODE ASSIST
(function () {
    // pt inputuri ce au nevoie de asistare complexa din js 
    // am in cmt {"sqltype":"code"}
    function Input_coder() {
        var $ = this;
        $.frame = _E();
        $.frame._(_E().css("background:orangered;width:.5em;height:.5em;border-radius:2em;position:absolute;margin-top:-0.5em; "));
    }
    Input_coder.prototype = {

    };

    Q.AST.code = new Input_coder();
    Q.AST.code.config = function (elm) {
        if (elm.cdf.code) {
            Q.AST.awake = true;
            elm.cdf.code.bind(this)(elm);
        }
    };
})();



// SET_LISTER --  asemanator cu listerul doar ca face apend la input-ul target si nu se autoconfigureaza dupa continutul acestuia
function SetLister(invoker) {
    var $ = this;
    $.invoker = invoker;
    $.readed = {};
    $.frame = _E().css("position:absolute;z-index:2;background:orange;border:1px solid #ccc;").setA("escdie");
    $.head = _E();
    $.kill = _E("kill").css("float:right");
    $.kill.on("click", function () {
        $.invoker.awake = false;
    });
    $.null_btn = _E('<span letter_btn class="glyphicon glyphicon-trash"></span>').css("border:none;padding:.35em .5em");
    $.null_btn.on("click", ev => {
        $.update_target(null);
    });
    $.panel = _E("<ul lister_panel style=''></ul>").css("min-width:22em;");
    $.panel.on("click", function (ev) {
        var tg = ev.target, li = tg.tagName === "LI" ? tg : tg.closest("li");
        li.sv ? $.update_target(li.sv, 'special_value') : $.update_target(li.all_data[$.ref_col]);
    });
    $.title = _E("span").css("display:inline-block;margin-left:1em;padding:.3em");
    $.input = _E("input").setA({ _type: "number", _max: 9999 }).css("margin:0;border-radius:0;width:5em;min-width:0;padding:.3em");
    $.input.set_lister = $;
    $.frame._($.head._($.null_btn, $.input, $.title, $.kill), $.panel);
    $.input.on("keyup", $.react_to_typing.bind($));
    $.input.on("focus", (ev) => {
        if ($.mns == 0) {
            $.input.fire("keyup", { which: 13 })
        }
    })

}

SetLister.prototype = {
    config: function (elm) {
        var $ = this;
        $.panel.html = '';
        $.target = elm;
        $.title.html = "add " + $.target.name;
        $.input.cdf = elm.cdf;
        $.ref = elm.cdf.cmt.ref;
        $.mns = elm.cdf.cmt.mns;
        var arr = $.ref.split(".");
        $.ref_tb = (arr.length === 2 ? arr[0] : arr[0] + "." + arr[1]) || "";
        $.ref_col = (arr.length === 2 ? arr[1] : arr[2]) || "";
        ;
        if (!$.readed.hasOwnProperty($.ref)) {
            $.readed[$.ref] = {}; // locul de memorare a listelor citite anterior 
        }
        // cum configurez inputul ajutator ca sa se comporte ca un lister de CAEN+
        //Q.AST.awake;
        setTimeout(
            function () {
                $.input.value = null;
                !Q.AST.awake && $.input.focus();
                //console.log("buba la focus");
            },
            100
        );
    },
    react_to_typing: function (ev) {
        var $ = this, val = $.input.value, len = val.length, mns = $.input.cdf.cmt.mns;
        if ([38, 40, 13].has(ev.which) && $.panel.html !== '') { // daca am panelul cu rezultate populat fac navigare cu sagetile si selectie cu ENTER
            $.navigate(ev);
        }
        else {
            $.panel.html = '';
            if (len >= mns) {
                var loaded = $.readed[$.ref][$.search_segment];
                loaded && loaded.length && 0  // !!!BAC>>> 
                    ? $.build_list(val) : $.fetch();
            }
            if (ev.ctrlKey && ev.key === 'x') {
                $.null_btn.click();
            }
        }
    },
    build_list: function () {
        var $ = this,
            docfg = document.createDocumentFragment(),
            val = $.input.value,
            D = $.readed[$.ref][$.search_segment];
        console.log($.input.cdf);
        if ($.input.cdf.cmt.hasOwnProperty("sv")) {
            var SV = $.input.cdf.cmt.sv;
            console.log(SV);
            if (typeof SV == 'string') {
                SV = [SV];
            }
            SV.map(sv => {
                docfg._($.make_li({ sv }));
            })
        }
        D.map(function (set) {
            if ((set[$.ref_col] + "").indexOf(val) >= 0) {
                docfg._($.make_li(set));
            }
        });
        $.panel._(docfg);
    },
    make_li: Lister.prototype.make_li,
    fetch: function () { // AR TRBUI O LOGICA MNS cu memorarea stringului pt care s-a facut citirea + setul de date
        var $ = this, post = {
            tb_name: $.ref_tb,
            where: $.ref_col + " LIKE '" + $.input.value + "%'",
            type: 2
        };
        let O = $.input.cdf.cmt;
        if (O.hint) {
            post.cols = ["id", ...O.hint].join(",");
        }
        if (O.where) {
            post.where += " AND " + O.where;
        }

        clearTimeout($.timer);
        $.xhr && $.xhr.abort();// daca am un ask lansat 
        !!LS.verbose && console.log(post); // SEE IN CONSOLE 
        $.timer = setTimeout(
            function () {
                ask("db\\read.val", post, function (rez) {
                    $.readed[$.ref][$.search_segment] = rez.parsed;
                    $.xhr = null;
                    $.timer = null;
                    $.build_list();
                }, null, { target: $.title, loader: "local_loader", mem: $ });  //!!!BAC!!!  mem   --> Q.ajax $.xhr=request 
            },
            300);
    },
    navigate: function (ev) {
        var $ = this;
        var sel = $.panel.find("[selected]", 1);
        var sense = typeof ev === 'string' ? ev : ev.which;
        if (!sel) {
            $.panel.first.setA("selected");
        }
        else {
            sel.remA("selected");
            switch (sense) {
                case "up":
                case 38: // up
                    $.target && $.target.set_cursor_poz('last');
                    if (sel.prev) {
                        sel.prev.setA("selected");
                        $.panel.scrollTop = sel.prev.offsetTop;
                    }
                    else {
                        //$.panel.last.setA('selected');
                        // $.panel.scrollTop=$.panel.scrollHeight-5;
                    }
                    break;
                case "down":
                case 40: // down
                    if (sel.next) {
                        sel.next.setA("selected");
                        $.panel.scrollTop = sel.next.offsetTop;
                    }
                    else {
                        sel.setA("selected");
                        //$.panel.first.setA("selected");
                        //$.panel.scrollTop=-5;
                        $.panel.scrollTop = $.panel.scrollHeight;
                    }
                    break;
                case "take":
                case 13:
                    $.update_target(sel.all_data[$.ref_col]);
                    break;
            }
        }
    },
    update_target: function (add, sv = false) {
        var $ = this;
        var rgx = new RegExp("\\b" + add + "\\b", 'gim'), in_set = rgx.test($.target.value + "");
        if (in_set) {
            $.target.show_error("ALREADY IN SET", .7, 'top');
        }
        else {
            if (sv) {
                $.target.value = add;
            }
            else {

                $.target.value = add === null ? null : ($.target.value.replace(/^[^\d]*/, '') + " " + add).trim();
            }
            $.target.tagName === "TEXTAREA" && $.target.auto_resize_height();
            $.target.fire("change");
            setTimeout(
                function () {
                    $.invoker.pin();
                },
                0
            );
        }
    }


};
Object.defineProperties(SetLister.prototype, {
    search_segment: {
        get: function () {
            var $ = this;
            return $.input.value.substr(0, $.mns);
        }
    },
    toString: {
        value: function () {
            return "SetLister";
        }
    }
});

Q.AST.set_lister = new SetLister(Q.AST);















// CASCADE
// cascading inputs 
// elementul cascading_from la change reseteaza elementul cascading_to
// elementul cascading_to foloseste in query ceva de genul WHERE cascading_from.name = cascading_from.value
// ex localitatile sunt grupate pe judetze , judetele sunt grupate pe regiuni 
// placeholderul ar trebui sa descrie alegerea ce trebuie facuta dupa noua valoare din cascading from
(function () {
    return;
    function cascading_hnd(ev) {
        var to = this.cascade_to;
        to.value = null;
        to.cascade_cleared = 1;
        to.fire("change", { cascading: 1 });
    }
    function require_value_above(ev) {
        var A = this.cascade;
        if (!A.value) {
            A.scroll2view();
            A.shup({ info: "REQUIRED FIRST", time: 2 });
            A.focus();
            this.value = null;
        }
    }
    Object.defineProperty(EP, "cascade", {
        get: function () {
            return this.cascade_from;
        },
        set: function (elm) {
            var $ = this;
            if (!$.talk_above) {
                this.on("focus", require_value_above);
                $.talk_above = 1;
            }
            if (!elm) {
                if ($.cascade_from) {
                    $.cascade_from.off("change", cascading_hnd);
                    $.cascade_from.cascade_to = null;
                }
            }
            else {
                elm.on("change", cascading_hnd);
                elm.cascade_to = $;
            }
            $.cascade_from = elm;
        }
    });
})();




EP.filter_for = function (a = []) { // de asociat (partial) cu EP.resets --- session.modify_data_on_change
    var m_elm = this;
    a.map(s_elm => {
        if (!m_elm.hasOwnProperty("master_for")) {
            m_elm.master_for = [];
        }
        m_elm.master_for.push(s_elm);
        s_elm.on("focus", function (ev) {
            if (!m_elm.value) {
                m_elm.show_error("PRIORITAR").then(() => m_elm.focus());
            }
        });
    });
};




EP.get_maped_data = function (cb) {
    var L = Q.AST.lister, CH = new Chain();
    if (this.value) {
        L.target = this;
        L.fetch(this.value, function (rez) {
            var R = rez.parsed[0];
            if (R) {
                L.target.real_value = R[L.target.name];
                L.target.all_data = R;
            }
            cb && cb.bind(L.target)(R);
            CH.resolve(R);
        });

    }
    else {
        CH.resolve(null);
    }
    return CH;
};



